var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "stepper d-flex justify-content-between align-items-center"
  }, _vm._l(_vm.steps, function (step, index) {
    return _c('div', {
      key: index,
      staticClass: "step d-flex flex-column align-items-center",
      on: {
        "click": function click($event) {
          return _vm.$emit('onClickStep', index);
        }
      }
    }, [_c('div', {
      staticClass: "circle",
      class: {
        active: _vm.currentStep === index
      }
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('div', {
      staticClass: "label mt-2"
    }, [_vm._v(_vm._s(step))]), index < _vm.steps.length - 1 ? _c('div', {
      staticClass: "line flex-grow-1"
    }) : _vm._e()]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }